exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".thumb[data-v-643a52db]{height:52px;width:52px;-o-object-fit:cover;object-fit:cover}", ""]);

// exports
